import type { ChangeEvent } from 'react';
import type { Profile } from './types';

function Toggle({ checked, onChange, disabled }: { checked: boolean; onChange: (v: boolean) => void; disabled?: boolean }) {
  return <label className="fig-toggle"><input type="checkbox" checked={checked} disabled={disabled} onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)} /><span /></label>;
}

export function PrivacyPanel({ membership, authorizedCount, onUpdate, busy }: {
  membership: Profile['memberships'][number];
  authorizedCount: number;
  onUpdate: (patch: { shareLocation: boolean }) => void;
  busy?: boolean;
}) {
  return <section className="privacy-panel">
    <h1>Privacy &amp; Permissions</h1>
    <p>You decide who can see you. There is one switch here and one decision per person — nothing else to configure.</p>

    <div className={`privacy-master${membership.shareLocation ? '' : ' paused'}`}>
      <div>
        <strong>Share my device location</strong>
        <span>{membership.shareLocation
          ? authorizedCount
            ? `On · visible to ${authorizedCount} authorized ${authorizedCount === 1 ? 'person' : 'people'}`
            : 'On · but you have not authorized anyone yet'
          : 'Paused · nobody can see you, including people you authorized'}</span>
      </div>
      <Toggle checked={membership.shareLocation} onChange={v => onUpdate({ shareLocation: v })} disabled={busy} />
    </div>

    <div className="privacy-list">
      <div>
        <small>Who can see my location</small>
        <strong>{membership.shareLocation ? `${authorizedCount} authorized ${authorizedCount === 1 ? 'person' : 'people'}` : 'Nobody while sharing is paused'}</strong>
        <span>Choose them individually under “Who can see you”. Family membership alone grants nothing.</span>
      </div>
      <div>
        <small>What an authorized person can do</small>
        <strong>Live location, history, Find Now, Ping, place alerts</strong>
        <span>Authorization is all or nothing, so there is no partial state to misread in an emergency.</span>
      </div>
      <div>
        <small>Location history retention</small>
        <strong>30 days</strong>
        <span>Configured by the current server retention policy</span>
      </div>
    </div>

    <div className="last-request">
      <small>LOCATION REQUEST TRANSPARENCY</small>
      <strong>Find Now requests are correlated and auditable</strong>
      <span>Every request is logged against the person who made it, and you can remove anyone’s access at any time.</span>
    </div>
  </section>;
}
